import { render, staticRenderFns } from "./MessageTip.vue?vue&type=template&id=56096f5c&scoped=true"
import script from "./MessageTip.vue?vue&type=script&lang=js"
export * from "./MessageTip.vue?vue&type=script&lang=js"
import style0 from "./MessageTip.vue?vue&type=style&index=0&id=56096f5c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56096f5c",
  null
  
)

export default component.exports